import { type Context, createContext, useContext } from 'react';

export type NavigationStyle = {
	backgroundColor: string;
	borderColor: string;
	borderType: 'NO_BORDER' | 'BOTTOM_BORDER' | 'ALL_BORDER';
	// `null` = no explicit navbar override -> inherit the hub-wide --hub-corner-radius
	// (only meaningful when the corner-radius feature is enabled). Gate off, it is
	// always coerced to a number (default 8).
	cornerRadius: number | null;
	fixedAtTop: boolean;
	padding: boolean;
	textColor: string;
};

export type NavigationStyleContextType = {
	options: NavigationStyle | null;
	setOptions: (options: NavigationStyle) => void;
};

const noop = () => {};

export const NavigationStyleContext: Context<NavigationStyleContextType> =
	createContext<NavigationStyleContextType>({
		options: null,
		setOptions: noop,
	});

export const useNavigationStyle = (): NavigationStyleContextType =>
	useContext(NavigationStyleContext);
